var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.arpdau_card.series)?_c('statistic-card-with-area-chart',{attrs:{"icon":"UsersIcon","statistic":'$ ' + _vm.arpdau_card.arpdau,"statistic-title":"ARPDAU","chart-data":_vm.arpdau_card.series,"chart-options":_vm.chartOptions}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }